import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listEdictos:[],
  listMunicipios:[],
  resultFile: [],
};
export const mutations = {
  
  GET_EDICTOS({ context }, edictos) {
    let edictos_array = [];
    Object.entries(edictos).forEach(([key, val]) => edictos_array.push(val));
    return (state.listEdictos = edictos_array);
  },
  GET_MUNICIPIOS({ context }, municipios) {
    let municipios_array = [];
    Object.entries(municipios).forEach(([key, val]) => municipios_array.push(val));
    return (state.listMunicipios = municipios_array);
  },
  GET_FILES({ context }, data) {
    state.resultFile = Object.assign({}, data);
  },
};
export const actions = {
  GET_EDICTOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_EDICTOS", response.data.data.edictos.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_EDICTO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_EDICTO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_EDICTO({ commit }, dataUser) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_EDICTO", response.data.data.edictos.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_EDICTO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_EDICTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          // commit("GET_EDICTO", response.data.data.edictos.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_FILE_EDICTOS({ commit }, data) {
    // data puede ser un id (number) o un objeto {id, modo}
    const id = typeof data === 'object' ? data.id : data;
    const modo = typeof data === 'object' ? data.modo : 'descargar';
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getFile(id, modo)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  PRESIGNED_UPLOAD_EDICTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  CONFIRM_UPLOAD_EDICTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  RETRY_UPLOAD_EDICTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  // RUN_SCRIPT_PUBLICACIONES({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         //console.log("runscript",response);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         //console.log("erro runscript",error);
  //         reject(error);
  //       });
  //   });
  // },
};

export const getters = {//leer datos
  listEdictos: state => state.listEdictos,
  // listMunicipios: state => state.listMunicipios,
};
